import { validateSelection } from "../../../utils/helpers/text";

export const getHierarchyQualificationStatus = (item, storeGxpReadys) =>
  item?.addInfo?.currentGxPStatusFromLogs ||
  validateSelection(storeGxpReadys, {
    key: item?.qualificationStatus
  }) ||
  item?.qualificationStatus;